<template>
<div class="form-group">
    <label class="form-item has-label"
      v-bind:class="{'has-error': errors.has(field.key), 'form-item-disabled': field.disabled}">
      <small class="label" v-html="sanitizedFieldTitle">
        {{ field.title }}
      </small>
      <input type="text"
        class="form-control form-input"
        v-bind:name="field.key"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        v-validate="validationRules"
        v-bind:data-vv-as="strippedFieldTitle"
        v-bind:disabled="field.disabled"
        tabindex="1">
    </label>
    <small class="form-help-text" v-html="sanitizedHelpText"></small>
    <span class="invalid-feedback"
      v-if="errors.has(field.key)">
      {{ errors.first(field.key) }}
    </span>
  </div>
</template>

<script>
import InputMixin from '@/mixins/InputMixin';

/**
 * Input String
 * -- Implements v-model
 *
 * A field that renders a text input.
 */
export default {
  name: 'InputText',
  mixins: [
    InputMixin,
  ],
  props: {
    disabled: Boolean,
  },
};
</script>
